// @flow
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CheckoutAsyncError from "../components/CheckoutAsyncResponse/CheckoutAsyncError";

import { actions as AlertActions } from "../../../alert/duck";
import { replace } from "react-router-redux";

function mapDispatchToProps(dispatch: Function) {
  return {
    ...bindActionCreators({
      ...AlertActions,
      goToRedirect: (route: string) => replace(route),
    }, dispatch),
    dispatch,
  }
}

export default connect(undefined, mapDispatchToProps)(CheckoutAsyncError)



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/containers/CheckoutAsyncErrorContainer.js